<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span> <em name="Exhibition"></em> <span>/</span>電子邀請函
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div>
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="PcDevice">
          <div class="contentBoxStatus py-3">
            <div class="d-flex align-items-center justify-content-around">
              <div
                v-for="(item, index) in MenuInvitation"
                :key="index"
                class="btn btn-white py-2 px-4"
                style="border-radius: 20px; border-color: #d9d9d9"
                @click="InviteLink(item.Url)"
              >
                <span
                  class="font-weight-bold text-primary"
                  style="font-size: 16px"
                  v-if="item.MenuName == '電子邀請函'"
                >
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
                <span v-else> <i class="fas fa-caret-right"></i> {{ item.MenuName }} </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>

        <div class="contentBox">
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="@/assets/images/iconInvite.svg" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <!-- <div class="MbDevice">
                        <h1> <img src="images/iconInvite.svg" width="35px" class="mb-1"> 電子邀請函</h1>
                    </div> -->

            <div class="MbDevice">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div>
                    <img src="@/assets/images/iconInvite.svg" width="35px" class="mt-1 mr-1" />
                  </div>
                  <div>
                    <h1>電子邀請函</h1>
                  </div>
                </div>

                <!-- <h1><img src="@/assets/images/iconInvite.svg" width="35px" class="mb-2" /> 電子邀請函</h1> -->
                <div class="mb-2">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <span class="border py-1 px-3">
                        <i class="fas fa-ellipsis-h"></i>
                      </span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in MenuInvitation" :key="index">
                        <span class="MbListGray" @click="InviteLink(item.Url)"> {{ item.MenuName }} </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>電子邀請函</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            <p>
              您可以產生專屬的邀請代碼及電子邀請函(EDM)，並轉發EDM或複製EDM網址分享給您的大量客戶，受邀客戶完成EDM內「邀請代碼索票」後，即可於展期憑「入場憑證
              QRcode」入場參觀。
            </p>
            <p class="my-3">&nbsp;</p>

            <ol class="number">
              <li>受邀客戶完成邀請代碼索票後即列入額度使用計算</li>
              <li>如額度提前使用完畢，尚需更多額度請洽大會業務人員</li>
              <li>
                邀請代碼索票至 <span class="red"><span name="CloseDay"></span> 23:59</span> 前截止，展期間恕不開放開通
              </li>
            </ol>
            <p class="lightLine">&nbsp;</p>
            <h3>專屬邀請代碼</h3>
            <p class="my-3">&nbsp;</p>

            <div v-if="!hasAccountId">
              <div class="alert alert-danger" role="alert">
                <img src="@/assets/images/tickGray.svg" width="16px" class="mb-1 mr-1" alt="" />
                專屬邀請代碼異常，請洽大會業務人員。
              </div>

              <h3 class="mt-4 mb-3">大會業務聯絡窗口</h3>
              <div name="ExpoContact"></div>
            </div>

            <div v-else>
              <p>以下為您的邀請代碼，可透過「使用次數」中的數字隨時掌握客戶展前開通之狀況。</p>
              <p class="my-3">&nbsp;</p>
              <div class="grayBG">
                <p>邀請函代碼：<span name="InvitationCode"></span></p>
                <p>使用次數：<span class="red" name="InvitationUsed"></span> / <span name="InvitationQuota"></span></p>
              </div>

              <div class="OpenBothInvite">
                <p class="lightLine">&nbsp;</p>
                <h3>發送電子邀請函EDM</h3>
                <p class="my-3">&nbsp;</p>
                <p>歡迎「轉發電子邀請函」或「複製電子邀請函網址」分享邀請代碼給您的重要客戶！</p>
                <p class="my-3">&nbsp;</p>
                <!-- tw -->

                <div class="ShowPhyInvite">
                  <h4 class="mb-4">
                    <span style="padding-bottom: 1px; border-bottom: 1px solid rgb(0, 0, 0)"> 實體展邀請函 </span>
                  </h4>

                  <div class="left">
                    <div class="grayBG">
                      <p class="bold">實體展中文版邀請函</p>
                      <p name="InvitationCodeHash"></p>
                      <input name="InvitationCodeHash" class="hiddenInput" type="text" value="" />
                      <p class="divider">&nbsp;</p>
                      <p class="divider">&nbsp;</p>
                      <div class="btnStyle mr-2" @click.prevent="SendMail('tw')">發送中文版</div>
                      <input type="button" value="複製網址" class="btnStyle copyURL" />
                    </div>
                  </div>
                  <!-- tw end -->
                  <!-- en -->
                  <div class="right">
                    <div class="grayBG">
                      <p class="bold">實體展英文版邀請函</p>
                      <p name="InvitationCodeHashEn"></p>
                      <input name="InvitationCodeHashEn" class="hiddenInput" type="text" value="" />
                      <p class="divider">&nbsp;</p>
                      <p class="divider">&nbsp;</p>

                      <!-- <input type="submit" value="發送英文版" class="btnStyle"> -->
                      <div class="btnStyle mr-2" @click.prevent="SendMail('en')">發送英文版</div>
                      <input type="button" value="複製網址" class="btnStyle copyURL" />
                    </div>
                  </div>
                </div>
                <p class="clear"></p>
                <div class="ShowOnlineInvite">
                  <h4 class="my-4">
                    <span style="padding-bottom: 1px; border-bottom: 1px solid rgb(0, 0, 0)"> 線上展邀請函 </span>
                  </h4>

                  <div class="left">
                    <div class="grayBG">
                      <p class="bold">線上展中文版邀請函</p>
                      <p name="OnlineInvitationCodeHash"></p>
                      <input name="OnlineInvitationCodeHash" class="hiddenInput" type="text" value="" />
                      <p class="divider">&nbsp;</p>
                      <p class="divider">&nbsp;</p>

                      <div class="btnStyle mr-2" @click.prevent="OnlineSendMail('tw')">發送中文版</div>
                      <input type="button" value="複製網址" class="btnStyle copyURL" />
                    </div>
                  </div>
                  <!-- tw end -->
                  <!-- en -->
                  <div class="right">
                    <div class="grayBG">
                      <p class="bold">線上展英文版邀請函</p>
                      <p name="OnlineInvitationCodeHashEn"></p>
                      <input name="OnlineInvitationCodeHashEn" class="hiddenInput" type="text" value="" />
                      <p class="divider">&nbsp;</p>
                      <p class="divider">&nbsp;</p>

                      <!-- <input type="submit" value="發送英文版" class="btnStyle"> -->
                      <div class="btnStyle mr-2" @click.prevent="OnlineSendMail('en')">發送英文版</div>
                      <input type="button" value="複製網址" class="btnStyle copyURL" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- en end -->
            <p class="clear"></p>
          </div>
          <p class="clear"></p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: '電子邀請函 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        CSRF_Token: '',
        RegNo: '',
        date: '',
        lang: 'tw',
        openOnlineInvite: '',
        openPhyInvite: '',
        Company_Code: '',
        AppNo: '',
        hasOnlineExh: '',
        hasPhyExh: '',
        ID_error: true,
        hasAccountId: true,
        MenuInvitation: [],
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },
    methods: {
      InviteLink(Url) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`
        }
      },
      SendMail(lang) {
        const vm = this
        const url = `/apiExhibitors/SendInvitation/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
        }

        // console.log(info)

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('實體展電子邀請函 (EDM) 已成功寄出至您參展資訊中所留的Email，歡迎多加廣發給您的重要客戶。')
          } else if (response.data.Code == 251) {
            alert('系統忙碌，請稍後再試！')
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('Email發生錯誤！')
          } else if (response.data.Code == 500) {
            alert('系統忙碌，請稍後再試！')
          }
        })
      },

      SendEnMail(lang) {
        const vm = this
        const url = `/apiExhibitors/SendInvitation/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
        }

        // console.log(info)

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('Physical exhibition E-invitation has been sent to your email. You can send it to your VIP clients.')
          } else if (response.data.Code == 251) {
            alert('System is busy, please try again later.')
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('Email error！')
          } else if (response.data.Code == 500) {
            alert('System is busy, please try again later.')
          }
        })
      },

      OnlineSendMail(lang) {
        const vm = this
        const url = `/apiExhibitors/SendInviteReg/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
          Type: 'Online',
        }

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('線上展電子邀請函 (EDM) 已成功寄出至您參展資訊中所留的Email，歡迎多加廣發給您的重要客戶。')
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert('系統忙碌，請稍後再試！')
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('Email發生錯誤！')
          }
        })
      },

      OnlineSendMailEn(lang) {
        const vm = this
        const url = `/apiExhibitors/SendInviteReg/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
          Type: 'Online',
        }

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('Online exhibition E-invitation has been sent to your email. You can send it to your VIP clients.')
          } else if (response.data.Code == 251) {
            alert('System is busy, please try again later.')
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('Email error！')
          } else if (response.data.Code == 500) {
            alert('System is busy, please try again later.')
          }
        })
      },
    },

    created() {
      const vm = this

      //取得語系

      let lang = 'tw'

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      //取得當前時間
      let theDate = new Date()
      vm.date = `${theDate.getFullYear()}/${theDate.getMonth() + 1}/${theDate.getDate()}`

      //取得是否開啟線上展權限
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        // console.log(response.data.Data)

        vm.openOnlineInvite = response.data.Data.OnlineExpo_Archived
        vm.openPhyInvite = response.data.Data.PhysicalExpo_Archived

        if (vm.openOnlineInvite == 1 || vm.openPhyInvite == 1) {
          $('.OpenBothInvite').addClass('ShowInviteTopic')
          $('.OpenBothInvite').removeClass('HideInviteTopic')
        } else {
          $('.OpenBothInvite').addClass('HideInviteTopic')
          $('.OpenBothInvite').removeClass('ShowInviteTopic')
        }

        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue

        //判定是否開放兩展邀請函

        //取得是否有線上展
        axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
          // console.log(response.data.Data)
          vm.hasOnlineExh = response.data.Data.Virtual
          vm.hasPhyExh = response.data.Data.physical
          vm.Company_Code = response.data.Data.Company_Code
          vm.AppNo = response.data.Data.AppNo

          let AccountID = response.data.Data.AccountID

          if (!AccountID) {
            vm.hasAccountId = false

            $.getJSON('/apiExhibitors/ExpoContact/' + vm.RegNo + '?lang=' + lang, function (data) {
              $('[name="ExpoContact"]').html(data.Data.ExpoContact)
            })
          } else {
            vm.hasAccountId = true
          }

          //判定開放實體邀請函

          if (vm.openPhyInvite == 1 && vm.hasPhyExh == 1) {
            $('.ShowPhyInvite').addClass('ShowInviteTopic')
            $('.ShowPhyInvite').removeClass('HideInviteTopic')
          } else {
            $('.ShowPhyInvite').addClass('HideInviteTopic')
            $('.ShowPhyInvite').removeClass('ShowInviteTopic')
          }
          //判定開放線上展邀請函

          if (vm.openOnlineInvite == 1 && vm.hasOnlineExh == 1) {
            $('.ShowOnlineInvite').addClass('ShowInviteTopic')
            $('.ShowOnlineInvite').removeClass('HideInviteTopic')
          } else {
            $('.ShowOnlineInvite').addClass('HideInviteTopic')
            $('.ShowOnlineInvite').removeClass('ShowInviteTopic')
          }

          //get invitation data
          $.getJSON('/apiExhibitors/Invitation/' + vm.RegNo, function (data) {
            // console.log(data)
            $('[name="InvitationCode"]').text(data.Data.InvitationCode)
            $('[name="InvitationQuota"]').text(data.Data.InvitationQuota)
            $('[name="InvitationUsed"]').text(data.Data.InvitationUsed)

            //tw URL
            let InvitationCodeHash =
              'https://www.chanchao.com.tw/visitorInvitation/edm.asp?code=' +
              data.Data.InvitationCodeHash +
              '&sno=' +
              vm.AppNo
            $('[name="InvitationCodeHash"]').text(InvitationCodeHash).val(InvitationCodeHash)
            //en URL
            let InvitationCodeHashEn =
              'https://www.chanchao.com.tw/en/visitorInvitation/edm.asp?code=' +
              data.Data.InvitationCodeHash +
              '&sno=' +
              vm.AppNo
            $('[name="InvitationCodeHashEn"]').text(InvitationCodeHashEn).val(InvitationCodeHashEn)

            //Online tw URL
            let OnlineInvitationCodeHash =
              'https://www.chanchao.com.tw/visitorInvitation/edm_reg_onlineexpo.asp?code=' +
              vm.Company_Code +
              '&sno=' +
              vm.AppNo +
              '&rno=' +
              vm.RegNo
            $('[name="OnlineInvitationCodeHash"]').text(OnlineInvitationCodeHash).val(OnlineInvitationCodeHash)

            //Online en URL
            let OnlineInvitationCodeHashEn =
              'https://www.chanchao.com.tw/en/visitorInvitation/edm_reg_onlineexpo.asp?code=' +
              vm.Company_Code +
              '&sno=' +
              vm.AppNo +
              '&rno=' +
              vm.RegNo
            $('[name="OnlineInvitationCodeHashEn"]').text(OnlineInvitationCodeHashEn).val(OnlineInvitationCodeHashEn)
          })
        })
      })

      $.getJSON('/apiExhibitors/Exhibition/' + vm.RegNo, { lang: lang }, function (data) {
        // console.log(data)

        //close day 展覽前一天23:59
        var CloseDay = new Date(data.Data.ExhBegin)
        CloseDay.setDate(CloseDay.getDate() - 1)
        $('[name="CloseDay"]').text(formatDate(CloseDay))
        function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()
          if (month.length < 2) month = '0' + month
          if (day.length < 2) day = '0' + day
          return [year, month, day].join('/')
        }

        // $.ajaxSettings.async = true; //開啟非同步執行

        //copy edm URL
        $('.copyURL').click(function () {
          let copyText = $(this).parent().parent().find('.hiddenInput')
          copyText.select()
          document.execCommand('Copy')

          if (vm.lang == 'tw') {
            alert('網址已複製')
          } else {
            alert('URL copied')
          }
        })
      })

      //取得邀請選單
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`)
        .then((response) => {
          // console.log(response.data.Data)
          vm.MenuInvitation = response.data.Data
        })
    },
  }
</script>

<style lang="scss">
  .alert-danger {
    background-color: #f8d7da;
  }

  .alert {
    padding: 10px 10px;
    font-size: 15px;
  }
</style>
